import React, { createContext, useState } from "react";
import locales from "./components/locales";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("tr"); // Varsayılan dil: Türkçe

  return (
    <LanguageContext.Provider value={{ language, setLanguage, translations: locales }}>
      {children}
    </LanguageContext.Provider>
  );
};
